import { apolloClient } from "@/plugins/vue-apollo.js";

const disableEnablePromotionCharge = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/fee/disable_enable_promotion_charges.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/fee/get_promotion_charges_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            }
          }
        };
        let allPromotionCharges = store.readQuery(query);
        store.writeQuery({
          ...query,
            data: allPromotionCharges,
            status: data
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { disableEnablePromotionCharge };
